(ns hai.contacts.mutations
  "Builders for the `:resolve` maps behind every contact mutation. Each returns
   `{:query ... :transform-fn ...}` with the fresh contact unwrapped from the
   response; surfaces assoc their own `:store-in` and follow-up fx on top.
   Mirrors [[hai.notes.mutations]]."
  (:require
   [clojure.string :as str]
   [hai.contacts.eql :as eql]))

(defn- trimmed
  "A typed value with its whitespace gone, nil when nothing is left — a blank
   sent to `contact/update` clears the field."
  [value]
  (not-empty (str/trim (or value ""))))

(defn- trimmed-all
  [values]
  (vec (keep trimmed values)))

(defn blank-payload?
  "Whether a composer's staged payload identifies nobody — what
   `contact/add-person` refuses."
  [{:keys [full-name emails github-login linkedin-url]}]
  (and (nil? (trimmed full-name))
       (empty? (trimmed-all emails))
       (nil? (trimmed github-login))
       (nil? (trimmed linkedin-url))))

(defn- params
  "The staged payload as `contact/add-person` / `contact/update` params. Every
   field goes, so an update replaces what the contact had — a cleared field
   is sent as nil."
  [{:keys [full-name emails organisation? github-login linkedin-url mailing-domains]}]
  {:contact/full-name             (trimmed full-name)
   :contact/email                 (trimmed-all emails)
   :contact/type                  (if organisation?
                                    :contact.type/organisation
                                    :contact.type/individual)
   :contact/github-login          (trimmed github-login)
   :contact/linkedin-url          (trimmed linkedin-url)
   :contact/org-mailing-namespace (trimmed-all mailing-domains)})

(defn save-resolve
  "Save a composer's staged payload onto `contact` (nil creates one) in one
   request, so the contact that comes back is the contact as saved. One arg
   joins the full editor shape; pass `contact-join` (e.g. `[:contact/uuid]`)
   when the caller discards the result."
  ([contact staged]
   (save-resolve contact staged eql/contact-eql))
  ([contact staged contact-join]
   (let [contact-uuid (:contact/uuid contact)
         mutation     (if contact-uuid 'contact/update 'contact/add-person)]
     {:query        [{(list mutation (cond-> (params staged)
                                       contact-uuid (assoc :contact/uuid contact-uuid)))
                      contact-join}]
      :transform-fn (fn [resp] (get resp mutation))})))

(defn delete-resolve
  [contact-uuid]
  {:query [(list 'contact/delete {:contact/uuid contact-uuid})]})
